package com.anjuros.website.redesign.sections.seo

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdEyebrow
import com.anjuros.website.redesign.components.RdPrimaryButton
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.styles.RdH2Style
import com.anjuros.website.redesign.styles.RdSectionFlushTopStyle
import com.anjuros.website.redesign.styles.RdSectionStyle
import com.anjuros.website.redesign.styles.SeoOngoingStyle
import com.anjuros.website.redesign.styles.SeoStackStyle
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.rdList
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

/** Points to the care plans that include ongoing SEO, without showing prices here. */
@Composable
fun SeoOngoingSection() {
    RdSection(
        labelledBy = "ongoing-h",
        modifier = RdSectionStyle.toModifier().then(RdSectionFlushTopStyle.toModifier()),
    ) {
        Div(SeoOngoingStyle.toModifier().toAttrs()) {
            Div(SeoStackStyle.toModifier().toAttrs()) {
                RdEyebrow(RdText.SEO_ONGOING_EYEBROW)
                H2(RdH2Style.toModifier().id("ongoing-h").toAttrs()) { Text(LocalText(RdText.SEO_ONGOING_TITLE)) }
                P { Text(LocalText(RdText.SEO_ONGOING_TEXT)) }
            }
            Div(SeoStackStyle.toModifier().toAttrs()) {
                Ul { rdList(LocalText(RdText.SEO_ONGOING_ITEMS)).forEach { Li { Text(it) } } }
                RdPrimaryButton(RdRoute.PRICING, RdText.SEO_ONGOING_BUTTON, withArrow = true)
            }
        }
    }
}
